import React from 'react';

import { Typography } from 'antd';

import { shortName } from 'segments/utils/helpers/shortName';

interface Props {
  userNames: string[];
  coachNames: string[];
  groupeName?: string | null;
  note?: string;
  balance: string;
}

function BookingDescription({
  userNames,
  coachNames,
  groupeName,
  note,
  balance
}: Props) {
  return (
    <div style={{
      position: 'absolute',
      backgroundColor: '#ffffff82',
      width: 'calc(100% - 8px)',
      left: '4px',
      top: '4px',
      zIndex: '1',
      padding: '1px',
      borderRadius: '12px',
      maxHeight: '60px',
      overflow: 'hidden',
      pointerEvents: 'none',
    }}
    >
      {groupeName && <Typography.Text style={{ display: 'block', fontSize: '12px' }} strong>{groupeName}</Typography.Text>}
      {
        (userNames[0] ?? false) && (
          <Typography.Text
            style={{ display: 'block', fontSize: '12px' }}
            strong
          >
            {`${shortName(userNames[0])} ${balance}₽${userNames.length > 1 ? ` (${userNames.filter((name) => name !== null).length})` : ''}`}
          </Typography.Text>
        )
      }
      {
        coachNames.map((coachName) => (
          <Typography.Text
            style={{ display: 'block', fontSize: '12px' }}
            type='secondary'
            key={coachName}
          >
            {shortName(coachName)}
          </Typography.Text>
        ))
      }
      {note && <Typography.Text style={{ display: 'block', fontSize: '12px' }} italic>{note}</Typography.Text>}
    </div>
  );
}

export default BookingDescription;
